import { render, staticRenderFns } from "./StepperHeader.component.html?vue&type=template&id=70ae0f05&scoped=true&external"
import script from "./StepperHeader.component.ts?vue&type=script&lang=ts&external"
export * from "./StepperHeader.component.ts?vue&type=script&lang=ts&external"
import style0 from "./StepperHeader.component.scss?vue&type=style&index=0&id=70ae0f05&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ae0f05",
  null
  
)

export default component.exports